import { OperandValue } from '../../shared/utils/filters';
import { USAGE_SUMMARY_SEARCH_FILTER_KEY } from './constants';
import { UsageSummary } from './interface';

export const getFilterKeyMatchValue = (filterKey: string, summary: UsageSummary): OperandValue => {
  switch (filterKey) {
    case 'status':
      return !summary.isDeleted ? 'true' : 'false';
    case 'region':
      return summary.region;
    case 'pipelineType':
      return summary.pipelineType;
    case USAGE_SUMMARY_SEARCH_FILTER_KEY:
      return [`${summary.pipelineSeqId}`, summary.sourceName, summary.destinationName];
    default:
      return undefined;
  }
};
